<template>
  <div class="info" id="info">
    <van-nav-bar @click-right="show = true">
      <div slot="title">第 {{ tid }} 题</div>
      <van-icon name="wap-nav" slot="right" />
    </van-nav-bar>
    <div v-for="(item, index) in data" :key="index">
      <van-cell>
        <template slot="title">
          <!-- <span class="title">{{ tid }}.</span> -->
          <!-- <span class="title">{{ tid }}.</span> -->
          <span v-html="item.text" class="title"></span>
        </template>
      </van-cell>
      <van-cell title=" ">
        <template slot="label">
          <div class="askLi" v-for="(rs, key) in item.options" :key="key">
            <van-row type="flex" align="center">
              <van-col :span="2">
                <span>{{ rs.option }}.</span>
              </van-col>
              <van-col :span="22" class="li">
                <span v-html="rs.text"></span>
              </van-col>
            </van-row>
          </div>
          <div class="askinfo">
            <div>
              本题用时：{{ item.use_time | format }}
              <!-- | 最佳用时：{{
                item.questionStandardTime | format
              }}-->
            </div>
            <div class="tit">
              正确答案：
              <span v-for="(rs, index) in item.answer" :key="index">
                {{
                rs
                }}
              </span>
              ，您的答案：
              <span v-for="(rs, index) in item.user_answer" :key="index">
                {{
                rs
                }}
              </span>
              <van-tag mark type="success" v-if="item.is_correct == 1">✔</van-tag>
              <van-tag mark type="danger" v-else>✘</van-tag>
            </div>
          </div>
        </template>
      </van-cell>
      <van-cell title=" ">
        <template slot="label">
          <div class="askinfo">
            <div class="desc">
              <!-- <van-icon name="records" /> -->
              <span v-html="item.jieda"></span>
            </div>
          </div>
        </template>
      </van-cell>
    </div>
    <div class="footer">
      <van-button block color="#409EFF" @click="goUrl">返回</van-button>
    </div>
    <van-popup v-model="show" position="right">
      <div class="spanbox">
        <div
          class="span"
          v-for="(item, index) in list"
          :key="index"
          :class="{
            success: item.is_correct == 1,
            danger: item.is_correct == 0,
            info: item.is_correct == 2
          }"
          @click="switchNum(item.question_id, item.name)"
        >{{ item.name }}</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { replaceinfo } from '@/common/index'
import { assessApi } from '@/api/index'
import weixinshare from '@/wxsdk/share'
export default {
  data() {
    return {
      show: false,
      examId: 0,
      questionId: 0,
      tid: 0,
      data: {
        text: '',
        options: []
      },
      list: []
    }
  },
  mounted() {
    this.tid = this.$route.query.tid
    this.examId = this.$route.params.eid
    this.questionId = this.$route.params.qid
    this.getExamQuestionLog()
    this.getExamQuestionList()
    const linkurl = 'https://' + window.location.host
    weixinshare(this.$titles, linkurl, this.$imgurls, this.$descs)
  },
  methods: {
    getExamQuestionLog() {
      let params = {
        examId: this.examId,
        questionId: this.questionId
      }
      assessApi.getExamQuestionLog(params).then(res => {
        if (res.success) {
          this.data = []
          res.data.forEach(item => {
            item.text = replaceinfo(item.text)
            item.options = item.options.map(rs => {
              rs.text = replaceinfo(rs.text)
              return rs
            })
            item.jieda = replaceinfo(item.jieda)
            this.data.push(item)
          })
          setTimeout(() => {
            window.MathJax.Hub.Queue([
              'Typeset',
              window.MathJax.Hub,
              document.getElementById('info')
            ])
          }, 10)
          this.show = false
        } else {
          this.$toast.fail('获取数据失败')
        }
      })
    },
    goUrl() {
      this.$router.go(-1)
    },
    getExamQuestionList() {
      let params = {
        examId: this.examId
      }
      assessApi.getExamQuestionLog(params).then(res => {
        if (res.success) {
          this.list = []
          res.data.forEach((item, index) => {
            let correct = item.is_normal == 0 ? 2 : item.is_correct
            let obj = {
              is_correct: correct,
              name: index + 1,
              question_id: item.question_id
            }
            this.list.push(obj)
          })
        } else {
          this.$toast.fail('获取数据失败')
        }
      })
    },
    switchNum(id, tid) {
      this.tid = tid
      this.questionId = id
      this.getExamQuestionLog()
    }
  },
  filters: {
    format: function(value) {
      if (value > 60) {
        let i = parseInt(value / 60)
        let m = value - 60 * i
        return i + '分' + m + '秒'
      } else {
        return value + '秒'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.info {
  padding-bottom: 50px;
  /deep/ img {
    max-width: 100%;
  }
  .success {
    color: #67c23a;
  }
  .danger {
    color: #f56c6c;
  }
  .title {
    font-size: 18px;
    /deep/ table {
      border-collapse: collapse;
      border: 1px #e4e7ed solid;
      td {
        border: 1px #e4e7ed solid;
      }
    }
  }
  .askLi {
    font-size: 15px;
    line-height: 30px;
    margin: 15px 0;
    color: #909399;
    .li {
      border-bottom: 1px dashed #eee;
    }
  }
  .askinfo {
    .tit {
      color: #303133;
      margin: 15px 0 3px;
      span {
        margin: 0 5px;
      }
    }
    .desc {
      line-height: 24px;
      .van-icon {
        font-size: 20px;
        color: #409eff;
      }
    }
  }
  .footer {
    width: 100%;
    background: #fff;
    position: fixed;
    left: 0%;
    bottom: 0;
    .van-button {
      width: 90%;
      margin: 0 5% 12px;
    }
  }
  .mjx-chtml {
    outline: 0;
  }
  .MJXc-display {
    overflow-x: auto;
    overflow-y: hidden;
  }
  .spanbox {
    overflow: hidden;
    .span {
      width: 30px;
      height: 30px;
      margin: 10px 5px 0;
      border-radius: 30px;
      text-align: center;
      line-height: 30px;
      color: #fff;
      font-size: 16px;
      display: inline-block;
    }
    .span.success {
      background-color: #44d9b1;
    }
    .span.danger {
      background-color: #ff4a4a;
    }
    .span.info {
      background-color: #c0c4cc;
      padding-bottom: 0;
    }
  }
  .van-popup--right {
    width: 100px;
    height: 100%;
    overflow: auto;
    text-align: center;
  }
}
</style>
